/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	/* eslint-disable no-console */

	jQuery(function ($) {
	  'use strict'; // eslint-disable-line

	  var isTouchDevice = function isTouchDevice() {
	    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	    var mq = function mq(query) {
	      return window.matchMedia(query).matches;
	    };

	    if ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch) {
	      return true;
	    }

	    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	    return mq(query);
	  };

	  var touchDevice = function touchDevice() {
	    if (isTouchDevice()) {
	      $('body').addClass('td');
	    } else {
	      $('body').addClass('no-td');
	    }
	  };

	  var windowWidth = function windowWidth() {
	    return $(window).width();
	  };

	  var equalHeights = function equalHeights(elm) {
	    var x = 0;

	    elm.height('auto');

	    elm.each(function (index, el) {
	      if ($(el).height() > x) {
	        x = $(el).height();
	      }
	    });

	    elm.height(x + 1);
	  };

	  // custom functions
	  var startNewDropdown = function startNewDropdown() {
	    var startNewBlock = $('#block-startnew');
	    var startNewMenu = startNewBlock.find('.menu');

	    startNewMenu.on('click', function (e) {
	      var $this = $(e.currentTarget);

	      if (!$this.hasClass('open')) {
	        $this.addClass('open');
	      } else {
	        $this.removeClass('open');
	      }
	    });

	    $(document).on('click', function (e) {
	      var $this = $(e.target);
	      !$this.closest('#block-startnew').length ? startNewMenu.removeClass('open') : null;
	    });
	  };

	  var select2Init = function select2Init() {
	    $('select').each(function (index, el) {
	      var $this = $(el);
	      var label = $this.parent().siblings('label');

	      // prepare some things before initialization
	      if ($this.attr('id') === 'edit-field-folder-shs-0-0') {
	        $this.find('option').eq(0).text('Select Folder');
	      }

	      if ($this.attr('id') === 'edit-field-folder-shs-0-1') {
	        $this.find('option').eq(0).text('Select Subfolder');
	      }

	      // init 
	      $this.select2({ minimumResultsForSearch: 20 });

	      var selectedOption = $this.next().find('.select2-selection');

	      // label override
	      if (label.length) {
	        selectedOption.prepend('<span class="select2-selection__label">' + label.html() + (!$this.hasClass('folder-select') ? ':' : '') + '</span>');
	      }
	    });

	    $('#edit-field-folder-shs-0-0, #edit-field-folder-shs-0-1').on('change', function (e) {
	      if ($(e.currentTarget).val() === '_none') {
	        select2Init();
	      }
	    });
	  };

	  var showMessages = function showMessages() {
	    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	    if ($('.c-messages').length) {
	      show ? $('.c-messages').addClass('shown') : $('.c-messages').removeClass('shown');
	    }
	  };

	  var closeMessages = function closeMessages() {
	    $('.c-messages--close').on('click', function (e) {
	      $(e.currentTarget).closest('.c-messages').removeClass('shown');
	    });
	  };

	  var sidebarCollapseExpand = function sidebarCollapseExpand() {
	    var sidebar = $('.c-sidebar');
	    var sidebarBtn = sidebar.find('.c-sidebar--btn');
	    var layout = $('.c-layout');

	    if (localStorage.getItem('sidebar-collapsed') == 'true') {
	      layout.addClass('sidebar-collapsed');
	      $('body').addClass('body-sidebar-collapsed').addClass('body-sidebar-collapsed-load');
	    }

	    sidebarBtn.on('click', function (e) {
	      var $this = $(e.currentTarget);
	      var isLeft = $this.hasClass('c-sidebar--btn-left');

	      $('body').removeClass('body-sidebar-collapsed-load');

	      if (isLeft) {
	        layout.addClass('sidebar-collapsed');
	        localStorage.setItem('sidebar-collapsed', true);
	        $('body').addClass('body-sidebar-collapsed');
	      } else {
	        layout.removeClass('sidebar-collapsed');
	        localStorage.setItem('sidebar-collapsed', false);
	        $('body').removeClass('body-sidebar-collapsed');
	      }
	    });
	  };

	  var assetLibraryAutoSubmit = function assetLibraryAutoSubmit() {
	    $('.c-asset-library--filters').find('select#edit-folder, select#edit-subfolder, select#edit-file-type').on('change', function (e) {
	      var $this = $(e.currentTarget);

	      if ($this.attr('id') === 'edit-folder') {
	        $('select#edit-subfolder').val('');
	        $('.c-asset-library--filters').find('.form-submit').trigger('click');
	      } else {
	        $('.c-asset-library--filters').find('.form-submit').trigger('click');
	      }
	    });
	  };

	  var faqCollapseExpand = function faqCollapseExpand() {
	    var faqLink = $('.view-help-faq').find('article > h2 > a');

	    faqLink.off('click').on('click', function (e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);
	      var article = $this.closest('article');
	      var articleBody = article.find('.article--body');
	      if (!article.hasClass('expanded')) {
	        article.addClass('expanded');
	        articleBody.stop().slideDown(300);
	      } else {
	        article.removeClass('expanded');
	        articleBody.stop().slideUp(300);
	      }
	    });
	  };

	  var memberSearchFormEnhance = function memberSearchFormEnhance() {
	    var memberForm = $('#views-exposed-form-members-page-1');
	    var submitBtn = memberForm.find('.form-submit');
	    var memberInput = memberForm.find('.form-item-name').find('input');

	    memberForm.find('.form-item-name').append('<a class="member-name-reset" href="javascript:;"><i class="fi-close"></i></a>');

	    var memberNameReset = $('.member-name-reset');

	    memberForm.find('select').on('change', function () {
	      submitBtn.trigger('click');
	    });

	    memberNameReset.on('click', function () {
	      memberInput.val('');
	      submitBtn.trigger('click');
	    });

	    memberInput.val() !== '' ? memberNameReset.addClass('visible') : memberNameReset.removeClass('visible');

	    memberInput.on('keyup', function (e) {
	      $(e.currentTarget).val() !== '' ? memberNameReset.addClass('visible') : memberNameReset.removeClass('visible');
	    });
	  };

	  var userMenuDropdown = function userMenuDropdown() {
	    var userMenu = $('.c-user-menu');
	    var userMenuLink = userMenu.find('.c-user-menu--trigger');

	    userMenuLink.on('click', function () {
	      if (!userMenu.parent().hasClass('opened')) {
	        userMenu.parent().addClass('opened');
	      } else {
	        userMenu.parent().removeClass('opened');
	      }
	    });

	    $(document).on('click', function (e) {
	      var $this = $(e.target);
	      !$this.closest('.c-user-menu').length ? userMenu.parent().removeClass('opened') : null;
	    });
	  };

	  var fullReviewQuestions = function fullReviewQuestions() {
	    var questionCat = $('.c-review--questions').children();
	    var questionCatTitle = questionCat.children('legend');

	    questionCatTitle.off('click').on('click', function (e) {
	      var $this = $(e.currentTarget);
	      var questions = $this.next();

	      if (!$this.closest('.ui-dialog').length) {
	        if (!$this.parent().hasClass('opened') && $('select[id*="edit-business-partner"]').val() !== '') {
	          $this.parent().addClass('opened');
	          questions.stop().slideDown(300);
	        } else {
	          $this.parent().removeClass('opened');
	          questions.stop().slideUp(300);
	        }
	      }
	    });

	    if ($('select[id*="edit-business-partner"]').val() === '' || $('.validation-wrapper').length) {
	      questionCat.children('legend').children('.fieldset-legend').addClass('disabled');
	      questionCatTitle.off('click');
	    } else {
	      questionCat.children('legend').children('.fieldset-legend').removeClass('disabled');
	    }
	  };

	  var disableBusinessPartner = function disableBusinessPartner() {
	    if ($('.page-full-review.page-create').length) {
	      if ($('select[id*="edit-market"]').val() === '') {
	        $('select[id*="edit-business-partner"]').attr('disabled', true);
	        $('select[id*="edit-business-partner').val('');
	      } else {
	        $('select[id*="edit-business-partner"]').attr('disabled', false);
	      }
	    }
	  };

	  var fullReviewResetForm = function fullReviewResetForm() {
	    if ($('.page-full-review.page-create').length) {
	      if ($('select[id*="edit-region"]').val() === '') {
	        $('select[id*="edit-market"]').attr('disabled', true);
	        $('select[id*="edit-market').val('');

	        // disable all topics
	        $('.c-review--category').removeClass('opened').children('legend').children('.fieldset-legend').addClass('disabled');

	        // slide up all opened topics and reset fields and indicator
	        $('.c-review--category').children('.fieldset-wrapper').slideUp(300);
	        $('.c-review--questions').find('input[id*="edit-node"]').prop('checked', false);
	        $('.c-review--actions').find('.form-submit').addClass('c-btn--disabled');
	        $('.question-indicator, .category-indicator').find('span').removeClass('answered');
	      } else if ($('.validation-wrapper').length) {
	        // disable all topics
	        $('.c-review--category').removeClass('opened').children('legend').children('.fieldset-legend').addClass('disabled');

	        // slide up all opened topics and reset fields and indicator
	        $('.c-review--category').children('.fieldset-wrapper').slideUp(300);
	        $('.c-review--questions').find('input[id*="edit-node"]').prop('checked', false);
	        $('.c-review--actions').find('.form-submit').addClass('c-btn--disabled');
	        $('.question-indicator, .category-indicator').find('span').removeClass('answered');
	      } else {
	        $('.c-review--filters').find('select[id*="edit-market"]').attr('disabled', false);
	      }
	    }
	  };

	  var tableRowLink = function tableRowLink() {
	    var trWithLink = $('tr[data-link]');

	    trWithLink.on('click', function (e) {
	      var link = $(e.currentTarget).attr('data-link');
	      window.location = link;
	    });
	  };

	  var questionAnswerIndicator = function questionAnswerIndicator() {

	    // append category indicator
	    if (!$('.category-indicator').length) {
	      var category = '';

	      $('.c-review--category').each(function () {
	        category += '<span></span>';
	      });

	      $('.page-full-review.page-create').find('.c-region--highlighted').append('<div class="category-indicator">' + category + '</div>');
	    }

	    $('.c-review--category').each(function (catIndex, cat) {
	      var answer = $(cat).children('.fieldset-wrapper').find('input[id*="edit-node"]');
	      var categoryIndicator = $('.category-indicator');
	      var question = $(cat).find('.c-review--question');

	      // reset question indicator
	      if ($('.c-review--filters').find('select[id*="edit-business-partner"]').val() !== '') {
	        question.each(function (questionIndex, question) {
	          var answered = $(question).find('input[id*="edit-node"]').is(':checked');
	          if (answered) {
	            console.log('answered');
	            $(cat).find('.question-indicator').find('span').eq(questionIndex).addClass('answered');
	          }
	        });

	        if ($('.full-review-form-edit').length) {
	          $(cat).addClass('opened').children('.fieldset-wrapper').stop().slideDown(300);
	        }
	      } else {
	        $(cat).removeClass('opened');
	        $(cat).children('.fieldset-wrapper').stop().slideUp(300);
	        $(cat).find('.question-indicator').find('span').removeClass('answered');
	      }

	      // reset category indicator
	      var questionAnswered = $(cat).find('.question-indicator').children('.answered').length;
	      var questionLength = $(cat).find('.question-indicator').children().length;

	      if (questionLength === questionAnswered) {
	        categoryIndicator.find('span').eq(catIndex).addClass('answered');
	      }

	      if ($('.c-review--filters').find('select[id*="edit-market"]').val() === '') {
	        categoryIndicator.find('span').eq(catIndex).removeClass('answered');
	      }

	      var categoryCount = categoryIndicator.children().length;
	      var categoryAnswered = categoryIndicator.children('.answered').length;

	      // enable full review submit
	      if (categoryCount === categoryAnswered && $('select[id*="edit-business-partner"]').val() !== '') {
	        $('.c-review--actions').find('.form-submit').removeClass('c-btn--disabled');
	      } else {
	        $('.c-review--actions').find('.form-submit').addClass('c-btn--disabled');
	      }

	      answer.off('click').on('change', function (e) {
	        var $this = $(e.currentTarget);
	        var category = $this.closest('.c-review--category');
	        var categoryIndex = $this.closest('.c-review--category').index();
	        var question = $this.closest('.c-review--question');
	        var index = +question.find('.c-review--question-count').text() - 1;
	        var questionIndicator = category.find('legend').find('.question-indicator');

	        // indicator for every question
	        questionIndicator.find('span').eq(index).addClass('answered');

	        var questionCount = questionIndicator.children().length;
	        var answeredQuestions = questionIndicator.children('.answered').length;

	        // indicator for every topic

	        if (questionCount === answeredQuestions) {
	          categoryIndicator.find('span').eq(categoryIndex).addClass('answered');
	        }

	        var categoryCount = categoryIndicator.children().length;
	        var categoryAnswered = categoryIndicator.children('.answered').length;

	        // enable full review submit
	        if (categoryCount === categoryAnswered && $('select[id*="edit-business-partner"]').val() !== '') {
	          $('.c-review--actions').find('.form-submit').removeClass('c-btn--disabled');
	        } else {
	          $('.c-review--actions').find('.form-submit').addClass('c-btn--disabled');
	        }
	      });
	    });
	  };

	  var beforeUnloadPopup = function beforeUnloadPopup(page, message) {
	    if (page.length) {
	      $(window).on('unload', function () {
	        confirm(message);
	      });
	    }
	  };

	  var answersLabelWrap = function answersLabelWrap() {
	    var answers = $('.c-review--question:not(.hide)').find('.form-radio');

	    answers.each(function (index, el) {
	      if (!$(el).next().find('.first-word').length) {
	        var answersLabel = $(el).next();
	        var labelArr = answersLabel.text().split(' ');
	        var firstWord = labelArr[0];
	        var rest = labelArr.filter(function (la, index) {
	          return index > 0;
	        });
	        answersLabel.html('<span class="first-word">' + firstWord + '</span><span>' + rest.join(' ') + '</span>');
	      }
	    });
	  };

	  var infiniteScroll = function infiniteScroll(wrapper) {
	    var ajaxProgress = $('.ajax-progress-infinite');
	    var pagination = $('.pager');
	    var resultsBody = $(wrapper);
	    var loading = false;
	    var next = pagination.find('.pager__item--next a').attr('href');
	    var noNextPages = false;

	    if (ajaxProgress.length) {
	      $(window).on('scroll', function (e) {
	        var wScroll = $(e.currentTarget).scrollTop();

	        if (wScroll + $(window).height() >= ajaxProgress.offset().top && !loading && !noNextPages && next !== '' && pagination.length) {
	          $.ajax({
	            url: next,
	            beforeSend: function beforeSend() {
	              loading = true;
	              ajaxProgress.addClass('ajax-in-progress');
	            }
	          }).done(function (data) {
	            var htmlPage = $(data);
	            var results = htmlPage.find(wrapper).html();

	            if (!htmlPage.find('.pager__item--next').length) {
	              next = '';
	              noNextPages = true;
	            } else {
	              next = htmlPage.find('.pager__item--next a').attr('href');
	            }

	            loading = false;
	            ajaxProgress.removeClass('ajax-in-progress');
	            resultsBody.append(results);
	          });
	        }
	      });
	    }
	  };

	  var radialProgressJSInit = function radialProgressJSInit() {
	    if ($('.radial-progress-chart').length) {
	      var colors = ['#95ADAC', '#E2D5BE', '#8DBADD', '#C5AD7E', '#5B788F', '#BD845B'];

	      var settings = {
	        series: null,
	        diameter: 30,
	        stroke: {
	          width: 20,
	          gap: 2
	        },
	        round: false,
	        animation: {
	          duration: 1800,
	          delay: 340
	        },
	        shadow: {
	          // width: 0
	        }
	      };

	      drupalSettings.reviewCategoriesData.map(function (cat, catIndex) {
	        // const sortedTopics = cat.topics.sort((a, b) => a.name < b.name ? -1 : 1);

	        settings.series = cat.topics.map(function (topic, topicIndex) {
	          $('.radial-progress-chart--legend').eq(catIndex).find('.radial-progress-chart--legend-square').eq(topicIndex).css({
	            'background-color': colors[topicIndex]
	          });

	          return {
	            value: topic.result,
	            color: {
	              solid: colors[topicIndex],
	              background: colors[topicIndex]
	            }
	          };
	        });

	        renderRadialProgressChart($('.radial-progress-chart[data-name="' + cat.name + '"]')[0], settings, cat.topics, colors);
	      });
	    }
	  };

	  var renderRadialProgressChart = function renderRadialProgressChart(element, settings, topics, colors) {
	    var radialChart = new RadialProgressChart(element, settings);
	    var chart = $(element);
	    var radialLegend = chart.next();

	    radialLegend.addClass('loaded');

	    chart.find('svg > g > g').on('mouseenter', function (e) {
	      var $this = $(e.currentTarget);
	      var currIndex = $this.index() - 2;
	      var tooltip = chart.find('.radial-progress-chart--tooltip');
	      var tooltipLabel = chart.find('.tooltip-label');
	      var tooltipValue = chart.find('.tooltip-value');
	      var group = chart.find('svg > g > g');
	      var groupLength = group.length;
	      var reverseIndex = groupLength - currIndex - 1;

	      tooltip.css({
	        top: 'calc(100% - ' + reverseIndex * (69 / groupLength) + 'px)'
	      }).addClass('visible');

	      tooltipLabel.text(topics[currIndex].name);
	      tooltipValue.html('<span style="background-color: ' + colors[currIndex] + '"></span>' + topics[currIndex].result + '%');
	    });

	    chart.find('svg > g > g').on('mouseleave', function (e) {
	      var tooltip = chart.find('.radial-progress-chart--tooltip');
	      tooltip.removeClass('visible');
	    });
	  };

	  var assChanged = false;
	  var notAssChanged = false;

	  var fullReviewRadarChartInit = function fullReviewRadarChartInit(element, chartData, type) {

	    var labels = [];
	    var datasets = [];

	    var compareColors = [];

	    if ($('.c-review-compare--table-row[data-color-rgb]').length) {
	      $('.c-review-compare--table-row[data-color-rgb]').each(function (index, el) {
	        compareColors.push($(el).attr('data-color-rgb'));
	      });
	    }

	    if (element.length) {
	      if (type == 'selfAssessment') {
	        // self assessment
	        if (element.hasClass('radar-chart')) {
	          var currentColor = '#005A2B';
	          var previousColor = 'rgba(158, 27, 50, 1)';

	          labels = chartData.labels;

	          datasets.push({
	            label: 'Current',
	            data: chartData.current,
	            fill: true,
	            backgroundColor: 'rgba(0, 90, 43, 0.2)',
	            borderColor: currentColor,
	            pointBackgroundColor: currentColor,
	            pointBorderWidth: 0,
	            pointBorderColor: currentColor
	          });

	          if (chartData.previous !== undefined) {
	            datasets.push({
	              label: 'Previous',
	              data: chartData.previous,
	              fill: true,
	              backgroundColor: 'rgba(158, 27, 50, 0.2)',
	              borderColor: previousColor,
	              pointBackgroundColor: previousColor,
	              pointBorderWidth: 0,
	              pointBorderColor: previousColor
	            });
	          }
	        }
	      }

	      if (type == 'compareAssessment') {
	        // full review compare assessment
	        labels = [['Customers', '& Collegues'], ['Business', 'Partners'], ['Operational', 'Foundations'], ['Commercial', 'Performace']];

	        chartData.map(function (cd, cdIndex) {
	          var assData = [];

	          cd.scores.map(function (s) {
	            return assData.push(Object.keys(s).map(function (e) {
	              return s[e];
	            }));
	          });

	          datasets.push({
	            label: cd.assessment,
	            data: assData,
	            fill: true,
	            backgroundColor: 'rgba(' + compareColors[cdIndex] + ', 0.1)',
	            borderColor: 'rgba(' + compareColors[cdIndex] + ', 1)',
	            pointBackgroundColor: 'rgba(' + compareColors[cdIndex] + ', 1)',
	            pointHoverBackgroundColor: 'rgba(' + compareColors[cdIndex] + ', 1)',
	            pointBorderWidth: 0,
	            pointHoverBorderWidth: 0,
	            pointHoverBorderColor: 'rgba(' + compareColors[cdIndex] + ', 1)'
	          });
	        });
	      }

	      var data = {
	        labels: labels,
	        datasets: datasets
	      };

	      var options = {
	        events: ['mousemove', 'mouseout', 'touchstart', 'touchend', 'touchend'],
	        tooltips: {
	          enabled: false,
	          xPadding: 0,
	          mode: 'nearest',
	          yPadding: 0,
	          custom: function custom(tooltipModel) {
	            // Tooltip Element
	            var tooltipEl = document.getElementById('chartjs-tooltip');

	            // remove carret bottom class on init
	            $(tooltipEl).children().removeClass('carret-bottom');

	            // Create element on first render
	            if (!tooltipEl) {
	              tooltipEl = document.createElement('div');
	              tooltipEl.id = 'chartjs-tooltip';
	              tooltipEl.innerHTML = '<div class="chart-tooltip"></div>';
	              document.body.appendChild(tooltipEl);
	            }

	            // Hide if no tooltip
	            if (tooltipModel.opacity === 0) {
	              tooltipEl.style.opacity = 0;
	              return;
	            }

	            // Set caret Position
	            tooltipEl.classList.remove('above', 'below', 'no-transform');
	            if (tooltipModel.yAlign) {
	              tooltipEl.classList.add(tooltipModel.yAlign);
	            } else {
	              tooltipEl.classList.add('no-transform');
	            }

	            function getBody(bodyItem) {
	              return bodyItem.lines;
	            }

	            // Set Text
	            if (tooltipModel.body) {
	              var titleLines = tooltipModel.title || [];
	              var bodyLines = tooltipModel.body.map(getBody);

	              var innerHtml = '<span class="chart-tooltip--carret"></span><div class="chart-tooltip--head">';

	              titleLines.forEach(function (title) {
	                innerHtml += '<span>' + title + '</span></br>';
	              });

	              innerHtml += '</div><div class="chart-tooltip--body">';

	              bodyLines.forEach(function (body, i) {
	                var bodyStr = body[0];
	                var label = bodyStr.split(' : ')[0];
	                var value = bodyStr.split(' : ')[1];

	                var colors = tooltipModel.labelColors[i];
	                var style = 'background:' + colors.backgroundColor;
	                var span = '<span class="chart-tooltip--square" style="' + style + '"></span>';
	                innerHtml += '<div class="chart-tooltip--item">' + span + '<span class="chart-tooltip--label">' + label + ': ' + value + '</span></div>';
	              });

	              innerHtml += '</div>';

	              var tableRoot = tooltipEl.querySelector('.chart-tooltip');
	              tableRoot.innerHTML = innerHtml;
	            }

	            // `this` will be the overall tooltip
	            var position = this._chart.canvas.getBoundingClientRect();

	            // Display, position, and set styles for font
	            tooltipEl.style.opacity = 1;
	            tooltipEl.style.position = 'absolute';
	            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX - $(tooltipEl).width() / 2 + 'px';
	            $(window).outerWidth() < 768 ? $(tooltipEl).find('.chart-tooltip--carret')[0].style.left = position.left + window.pageXOffset + tooltipModel.caretX - 20 + 'px' : null;
	            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 12 + 'px';
	            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
	            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
	            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
	            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
	            tooltipEl.style.pointerEvents = 'none';
	          },
	          callbacks: {
	            label: function label(tooltipItem, data) {
	              return data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%';
	            }
	          }
	        },
	        legendCallback: function legendCallback(chart) {
	          var legendHtml = '';

	          legendHtml = '<ul class="chart-legend chart-legend--id-' + chart.id + '">';

	          chart.data.datasets.map(function (dataset) {
	            legendHtml += '<li class="chart-legend--item">\n                                <span class="chart-legend--line color-' + (dataset.label ? dataset.label : 'NoColor') + '"></span>\n                                <span class="chart-legend--label">' + (dataset.label ? dataset.label + ' Results' : 'Not set') + '</span>\n                              </li>';
	            return legendHtml;
	          });

	          legendHtml += '</ul>';

	          return legendHtml;
	        },
	        legend: {
	          display: false
	        },
	        scale: {
	          pointLabels: {
	            fontStyle: 'bold',
	            fontSize: 13,
	            xPadding: 20,
	            yPadding: 20,
	            fontFamily: "'Arial', sans-serif"
	          },
	          ticks: {
	            max: 100,
	            min: 0,
	            stepSize: 20,
	            beginAtZero: true
	          }
	        }
	      };

	      if (type == 'compareAssessment') {

	        $('.c-review-compare--filters').find('select[id*="-review"]').each(function (index, el) {
	          // changed assessment
	          $(el).on('change', function () {
	            assChanged = true;
	          });
	        });

	        $('.c-review-compare--filters').find('select:not([id*="-review"])').each(function (index, el) {
	          // changed anything but assessments
	          $(el).on('change', function () {
	            notAssChanged = true;
	          });
	        });

	        if (chartData.length > 0 && assChanged && !notAssChanged) {
	          renderChart('radar', data, options, element);
	        } else if (chartData.length > 0 && !assChanged && !notAssChanged) {
	          renderChart('radar', data, options, element);
	        }

	        assChanged = false;
	        notAssChanged = false;
	      } else {
	        renderChart('radar', data, options, element);
	      }
	    }
	  };

	  var fullReviewTimeline = function fullReviewTimeline(element) {
	    var colors = ['#C5AD7E', '#5B788F', '#BD845B', '#95ADAC'];
	    var colorsHover = ['#9B8761', '#455D70', '#895F41', '#657877'];
	    var labelNames = ['Customers & Colleagues', 'Business Partners', 'Operational Foundations', 'Commercial Performance'];

	    var smallerWidthConst = $(window).outerWidth() < 992 ? 2 : 1;

	    if (element.length) {
	      element.each(function (index, el) {
	        var chartData = JSON.parse($('#full_review_timeline_data').val()).reverse();
	        var labels = [];
	        var datasets = [];
	        var overallScore = [];

	        var currentDatasetIndex = 0;

	        var scoresData = [[], [], [], []];

	        chartData.map(function (cd, cdIndex) {
	          var finalOverall = 0;

	          labels.push(cd.date);

	          cd.scores.map(function (score, scoreIndex) {
	            var finalScore = parseFloat(Object.keys(score).map(function (e) {
	              return score[e];
	            })[0] * 0.25);

	            scoresData[scoreIndex].push(finalScore);

	            finalOverall += finalScore;

	            overallScore[cdIndex] = finalOverall;

	            if (datasets[scoreIndex] === undefined) {
	              datasets[scoreIndex] = {
	                label: Object.keys(score)[0],
	                data: scoresData[scoreIndex],
	                type: 'bar',
	                yAxisID: '2ndAxis',
	                backgroundColor: colors[scoreIndex],
	                hoverBackgroundColor: colorsHover[scoreIndex],
	                borderWidth: 0
	              };
	            }
	          });
	        });

	        // add line dataset
	        datasets.unshift({
	          backgroundColor: 'rgba(30, 30, 30, 1)',
	          borderColor: 'rgba(30, 30, 30, 1)',
	          borderWidth: 2,
	          data: overallScore,
	          fill: false,
	          label: 'Overall Score',
	          lineTension: 0,
	          pointBackgroundColor: 'white',
	          pointBorderWidth: 2,
	          pointHoverBackgroundColor: 'white',
	          pointHoverBorderWidth: 2,
	          pointHoverRadius: 5,
	          pointRadius: 5,
	          type: 'line'
	        });

	        var data = {
	          labels: labels,
	          datasets: datasets
	        };

	        var options = {
	          events: ['mousemove', 'mouseout', 'touchstart', 'touchend'],
	          maintainAspectRatio: false,
	          cornerRadius: $('.page-dashboard').length ? 5 : 10,
	          legend: {
	            display: false
	          },
	          scales: {
	            yAxes: [{
	              gridLines: {
	                drawTicks: false
	              },
	              stacked: true,
	              id: '2ndAxis',
	              type: 'linear',
	              scaleLabel: {
	                labelString: 'bawda'
	              },
	              ticks: {
	                beginAtZero: true,
	                max: 100,
	                min: 0,
	                stepValue: 10,
	                steps: 10,
	                padding: 20,
	                fontFamily: "'Arial', sans-sefif",
	                fontSize: 14,
	                fontColor: '#525252',
	                fontStyle: 'bold',
	                callback: function callback(value, index, values) {
	                  return value + '%';
	                }
	              }
	            }],
	            xAxes: [{
	              gridLines: {
	                drawTicks: false,
	                display: false
	              },
	              stacked: true,
	              maxBarThickness: $('.page-dashboard').length ? 40 / smallerWidthConst : 60 / smallerWidthConst,
	              categoryPercentage: 0.6,
	              barPercentage: 1,
	              ticks: {
	                beginAtZero: true,
	                padding: 20,
	                fontFamily: "'Arial', sans-sefif",
	                fontSize: 14,
	                fontColor: '#525252',
	                fontStyle: 'bold'
	              }
	            }]
	          },
	          tooltips: {
	            mode: 'index',
	            intersect: false,
	            enabled: false,
	            xPadding: 0,
	            yPadding: 0,
	            custom: function custom(tooltipModel) {
	              // Tooltip Element
	              var tooltipEl = document.getElementById('chartjs-tooltip');

	              // remove carret bottom class on init
	              $(tooltipEl).children().removeClass('carret-bottom');

	              // Create element on first render
	              if (!tooltipEl) {
	                tooltipEl = document.createElement('div');
	                tooltipEl.id = 'chartjs-tooltip';
	                tooltipEl.innerHTML = '<div class="chart-tooltip"></div>';
	                document.body.appendChild(tooltipEl);
	              }

	              // Hide if no tooltip
	              if (tooltipModel.opacity === 0) {
	                tooltipEl.style.opacity = 0;
	                return;
	              }

	              // Set caret Position
	              tooltipEl.classList.remove('above', 'below', 'no-transform');
	              if (tooltipModel.yAlign) {
	                tooltipEl.classList.add(tooltipModel.yAlign);
	              } else {
	                tooltipEl.classList.add('no-transform');
	              }

	              function getBody(bodyItem) {
	                return bodyItem.lines;
	              }

	              // Set Text
	              if (tooltipModel.body) {
	                var bodyLines = tooltipModel.body.map(getBody);

	                var innerHtml = '<span class="chart-tooltip--carret"></span><div class="chart-tooltip--head fluid">';

	                innerHtml += '<span><strong>' + chartData[currentDatasetIndex].author + '<br/>(' + chartData[currentDatasetIndex].level + ')</strong></span></br>\n                                  <span>Region: <strong>' + chartData[currentDatasetIndex].region + '</strong></span></br>\n                                  <span>Market: <strong>' + chartData[currentDatasetIndex].market + '</strong></span></br>\n                                  <span>Business Partner: <strong>' + chartData[currentDatasetIndex].business_partner + '</strong></span></br>\n                                  <span>Overall Score: <strong>' + chartData[currentDatasetIndex].overall_score + '%</strong></span>';

	                innerHtml += '</div><div class="chart-tooltip--body revese">';

	                bodyLines.forEach(function (body, i) {

	                  if (bodyLines[i].length) {
	                    var bodyStr = body[0];
	                    var label = bodyStr.split(' : ')[0];
	                    var value = bodyStr.split(' : ')[1];

	                    var colors = tooltipModel.labelColors[i + 1];
	                    var style = 'background:' + colors.backgroundColor;
	                    var span = '<span class="chart-tooltip--square white-bg"><span style="' + style + '"></span></span>';
	                    innerHtml += '<div class="chart-tooltip--item">\n                                        ' + span + '\n                                        <span class="chart-tooltip--label">\n                                          ' + label + ' - ' + value + '\n                                        </span>\n                                    </div>';
	                  }
	                });

	                innerHtml += '</div>';

	                var tableRoot = tooltipEl.querySelector('.chart-tooltip');
	                tableRoot.innerHTML = innerHtml;
	              }

	              // `this` will be the overall tooltip
	              var position = this._chart.canvas.getBoundingClientRect();

	              // Display, position, and set styles for font
	              tooltipEl.style.opacity = 1;
	              tooltipEl.style.position = 'absolute';
	              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX - $(tooltipEl).width() / 2 + 'px';
	              $(window).outerWidth() < 768 ? $(tooltipEl).find('.chart-tooltip--carret')[0].style.left = position.left + window.pageXOffset + tooltipModel.caretX - 20 + 'px' : null;
	              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
	              tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
	              tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
	              tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
	              tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
	              tooltipEl.style.pointerEvents = 'none';
	            },
	            callbacks: {
	              afterLabel: function afterLabel(tooltipItem, data) {
	                currentDatasetIndex = tooltipItem.index;
	              },
	              label: function label(tooltipItem, data) {

	                var label = labelNames[tooltipItem.datasetIndex];
	                var currentChartData = chartData[tooltipItem.index];
	                var value = '';

	                if (currentChartData.scores[tooltipItem.datasetIndex] !== undefined) {
	                  value = '<span style="color: ' + colors[tooltipItem.datasetIndex] + '">' + Object.keys(currentChartData.scores[tooltipItem.datasetIndex]).map(function (e) {
	                    return currentChartData.scores[tooltipItem.datasetIndex][e];
	                  }) + '%</span>';
	                }

	                var labelAndScore = currentChartData.scores[tooltipItem.datasetIndex] !== undefined ? label + ' : ' + value : '';

	                return labelAndScore;
	              }
	            }
	          }
	        };

	        renderChart('bar', data, options, el);
	      });
	    }
	  };

	  var quickReviewBarChartInit = function quickReviewBarChartInit(element) {
	    if ($('#quick_review_data, #compare_data').length) {

	      // ac 1, ach 0.7, gc 0.25, gch 0.18

	      var dataColors = ['149,173,172', '91,120,143', '141,186,221', '64,70,92', '226,213,190', '197,173,126', '189,132,91', '108,70,70', '64,45,45', '78,36,85'];

	      var reviewData = JSON.parse($('#quick_review_data, #compare_data').val());

	      $(element).each(function (index, el) {
	        var labels = [];
	        var datasets = [];
	        var goal = [];
	        var actual = [];
	        var actualColorHoverSet = [];
	        var actualColorSet = [];
	        var goalColorHoverSet = [];
	        var goalColorSet = [];

	        var $this = $(el);
	        var chartName = $this.data('name');

	        var chartValues = [];

	        if (reviewData.length !== undefined) {

	          var compareColors = ['189,132,91', '64,70,92', '108,70,70', '149,173,172'];

	          var itemFieldsetSelector = $(window).outerWidth() < 768 ? '.item-fieldset.not-empty' : '.item-fieldset:not(.hidden)';

	          var compareDataInputs = $('.c-review-compare--filters').children(itemFieldsetSelector);

	          reviewData.map(function (rd, rdIndex) {

	            var ac = [];

	            // chart data index
	            var cdIndex = +compareDataInputs.eq(rdIndex).attr('id').split('-')[2];

	            // chart data name
	            var cdName = $('.c-review-compare--filters').children('.item-fieldset').eq(cdIndex).find('select[id*="-review"] option:selected').text();

	            // console.log(compareDataInputs.eq(rdIndex));

	            // prepare data for charts
	            rd[chartName].filter(function (d) {
	              return d.actual_clean.match(/[A-Za-z]+/g) === null;
	            }).map(function (cv, i) {

	              // console.log(labels.indexOf(cv.label) !== -1);

	              // console.log()
	              var checkIfExists = labels.indexOf(cv.label) !== -1;

	              if (!labels.indexOf(cv.label) !== -1) {
	                if (!checkIfExists) {
	                  labels.push(cv.label);
	                }
	              }

	              // console.log(rd);

	              ac[i] = cv.actual_clean;
	              actual[rdIndex] = ac;
	            });

	            // push data to datasets
	            datasets.push({
	              label: '' + cdName,
	              stack: 'Stack ' + rdIndex,
	              backgroundColor: 'rgba(' + compareColors[cdIndex] + ',1)',
	              hoverBackgroundColor: 'rgba(' + compareColors[cdIndex] + ',1)',
	              borderColor: 'rgba(' + compareColors[cdIndex] + ',1)',
	              hoverBorderColor: 'rgba(' + compareColors[cdIndex] + ',1)',
	              borderWidth: 1,
	              data: actual[rdIndex]
	            });
	          });

	          // console.log(datasets);
	        } else {

	          chartValues = reviewData[chartName].filter(function (d) {
	            return d.actual_clean.match(/[A-Za-z]+/g) === null;
	          });

	          chartValues.map(function (cv, i) {
	            labels.push(cv.label);
	            goal.push(cv.market_objective_clean);
	            actual.push(cv.actual_clean);
	            actualColorHoverSet.push('rgba(' + dataColors[i] + ',0.7)');
	            actualColorSet.push('rgba(' + dataColors[i] + ',1)');
	            goalColorHoverSet.push('rgba(' + dataColors[i] + ',0.18)');
	            goalColorSet.push('rgba(' + dataColors[i] + ',0.25)');
	          });

	          datasets.push({
	            label: 'Actual',
	            stack: 'Stack 0',
	            backgroundColor: actualColorSet,
	            hoverBackgroundColor: actualColorHoverSet,
	            borderColor: actualColorSet,
	            hoverBorderColor: actualColorHoverSet,
	            borderWidth: 1,
	            data: actual
	          }, {
	            label: 'Objective',
	            stack: 'Stack 1',
	            backgroundColor: goalColorSet,
	            hoverBackgroundColor: goalColorHoverSet,
	            borderColor: actualColorSet,
	            hoverBorderColor: actualColorHoverSet,
	            borderWidth: 1,
	            data: goal
	          });
	        }

	        var data = {
	          labels: labels,
	          datasets: datasets
	        };

	        var options = {
	          events: ['mousemove', 'mouseout', 'touchstart', 'touchend'],
	          legend: {
	            display: false
	          },
	          layout: {
	            padding: {
	              left: 15
	            }
	          },
	          barRoundness: 0.4,
	          maintainAspectRatio: false,
	          scales: {
	            xAxes: [{
	              gridLines: {
	                display: false,
	                drawBorder: true,
	                color: '#5B788F',
	                lineWidth: 1
	              },
	              maxBarThickness: 20,
	              categoryPercentage: 0.3,
	              barPercentage: 0.8
	            }],
	            yAxes: [{
	              gridLines: {
	                display: false,
	                drawBorder: false
	              },
	              ticks: {
	                display: false
	              }
	            }]
	          },
	          tooltips: {
	            mode: 'index',
	            intersect: false,
	            enabled: false,
	            xPadding: 0,
	            yPadding: 0,
	            custom: function custom(tooltipModel) {
	              // Tooltip Element
	              var tooltipEl = document.getElementById('chartjs-tooltip');

	              // remove carret bottom class on init
	              $(tooltipEl).children().removeClass('carret-bottom');

	              // Create element on first render
	              if (!tooltipEl) {
	                tooltipEl = document.createElement('div');
	                tooltipEl.id = 'chartjs-tooltip';
	                tooltipEl.innerHTML = '<div class="chart-tooltip"></div>';
	                document.body.appendChild(tooltipEl);
	              }

	              // Hide if no tooltip
	              if (tooltipModel.opacity === 0) {
	                tooltipEl.style.opacity = 0;
	                return;
	              }

	              // Set caret Position
	              tooltipEl.classList.remove('above', 'below', 'no-transform');
	              if (tooltipModel.yAlign) {
	                tooltipEl.classList.add(tooltipModel.yAlign);
	              } else {
	                tooltipEl.classList.add('no-transform');
	              }

	              function getBody(bodyItem) {
	                return bodyItem.lines;
	              }

	              // Set Text
	              if (tooltipModel.body) {
	                var titleLines = tooltipModel.title || [];
	                var bodyLines = tooltipModel.body.map(getBody);

	                var innerHtml = '<span class="chart-tooltip--carret"></span><div class="chart-tooltip--head">';

	                titleLines.forEach(function (title) {
	                  // const desc = chartValues.find(d => d.label == title);
	                  innerHtml += '<span>' + title + '</span></br>';
	                });

	                innerHtml += '</div><div class="chart-tooltip--body">';

	                bodyLines.forEach(function (body, i) {
	                  var bodyStr = body[0];
	                  var label = bodyStr.split(' : ')[0];
	                  var value = bodyStr.split(' : ')[1];

	                  var colors = tooltipModel.labelColors[i];
	                  var style = 'background:' + colors.backgroundColor;
	                  var span = '<span class="chart-tooltip--square white-bg"><span style="' + style + '"></span></span>';
	                  innerHtml += '<div class="chart-tooltip--item">\n                                      ' + span + '\n                                      <span class="chart-tooltip--label">\n                                        ' + label + ' - <strong>' + value + '</strong>\n                                      </span>\n                                  </div>';
	                });

	                innerHtml += '</div>';

	                var tableRoot = tooltipEl.querySelector('.chart-tooltip');
	                tableRoot.innerHTML = innerHtml;
	              }

	              // `this` will be the overall tooltip
	              var position = this._chart.canvas.getBoundingClientRect();

	              // Display, position, and set styles for font
	              tooltipEl.style.opacity = 1;
	              tooltipEl.style.position = 'absolute';
	              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX - $(tooltipEl).width() / 2 + 'px';
	              $(window).outerWidth() < 768 ? $(tooltipEl).find('.chart-tooltip--carret')[0].style.left = position.left + window.pageXOffset + tooltipModel.caretX - 20 + 'px' : null;
	              tooltipEl.style.top = position.top + window.pageYOffset + this._chart.chartArea.bottom + 5 + 'px';
	              tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
	              tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
	              tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
	              tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
	              tooltipEl.style.pointerEvents = 'none';
	            },
	            callbacks: {
	              label: function label(tooltipItem, data) {

	                if (reviewData.length !== undefined) {

	                  var currentChartData = reviewData[0][chartName].filter(function (d) {
	                    return d.actual_clean.match(/[A-Za-z]+/g) === null;
	                  })[tooltipItem.index];

	                  var value = '';

	                  if (currentChartData.actual_value.indexOf('$') !== -1 && currentChartData.actual_value.indexOf('%') === -1) {
	                    value = '<span>$' + numberFormat('gb-GB', data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) + '</span>';
	                  }

	                  if (currentChartData.actual_value.indexOf('%') !== -1 && currentChartData.actual_value.indexOf('$') === -1) {
	                    value = '<span>' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%</span>';
	                  }

	                  if (currentChartData.actual_value.indexOf('%') === -1 && currentChartData.actual_value.indexOf('$') === -1) {
	                    value = '<span>' + numberFormat('gb-GB', data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) + '</span>';
	                  }

	                  return data.datasets[tooltipItem.datasetIndex].label + ' : ' + value;
	                } else {
	                  // not compare
	                  var _currentChartData = chartValues[tooltipItem.index];

	                  var _value = '';

	                  if (_currentChartData.actual_value.indexOf('$') !== -1 && _currentChartData.actual_value.indexOf('%') === -1) {
	                    _value = '<span class="' + (+_currentChartData.actual_clean >= +_currentChartData.market_objective_clean ? 'green' : 'red') + '">$' + numberFormat('gb-GB', data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) + '</span>';
	                  }

	                  if (_currentChartData.actual_value.indexOf('%') !== -1 && _currentChartData.actual_value.indexOf('$') === -1) {
	                    _value = '<span class="' + (+_currentChartData.actual_clean >= +_currentChartData.market_objective_clean ? 'green' : 'red') + '">' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%</span>';
	                  }

	                  if (_currentChartData.actual_value.indexOf('%') === -1 && _currentChartData.actual_value.indexOf('$') === -1) {
	                    if (_currentChartData.label === "Wholesale - no noise" || _currentChartData.label === "Regulatory Compliance") {
	                      _value = '<span class="' + (+_currentChartData.actual_clean <= +_currentChartData.market_objective_clean ? 'green' : 'red') + '">' + numberFormat('gb-GB', data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) + '</span>';
	                    } else {
	                      _value = '<span class="' + (+_currentChartData.actual_clean >= +_currentChartData.market_objective_clean ? 'red' : 'green') + '">' + numberFormat('gb-GB', data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) + '</span>';
	                    }
	                  }

	                  return data.datasets[tooltipItem.datasetIndex].label + ' : ' + _value;
	                }
	              }
	            }
	          }
	        };

	        renderChart('roundedBar', data, options, el);
	      });
	    }
	  };

	  var externalChart = null;

	  var renderChart = function renderChart(type, data, options, element) {
	    var update = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


	    var ctx = element;

	    var chart = null;

	    var ChartData = data;

	    if (type === 'line') {
	      if (!update) {
	        externalChart = new Chart(ctx, {
	          type: type,
	          data: data,
	          options: options
	        });
	      } else {
	        externalChart.config.data = data;
	        externalChart.update();
	      }
	    } else {
	      chart = new Chart(ctx, {
	        type: type,
	        data: data,
	        options: options
	      });
	    }

	    $('#show-goal').on('change', function (e) {
	      var $this = $(e.currentTarget);

	      if ($this.is(':checked')) {
	        externalChart.config.data = data;
	        externalChart.update();
	      } else {
	        var filteredData = ChartData.datasets.filter(function (ds) {
	          return !ds.label.indexOf('Objective') !== -1;
	        });
	        externalChart.config.data.datasets = filteredData;
	        externalChart.update();
	      }
	    });

	    if (type === 'radar' && chart !== null) {
	      $('.chart--legend').html(chart.generateLegend());
	    }
	  };

	  var quickReviewAdditional = function quickReviewAdditional() {
	    if ($('#quick_review_data').length) {
	      var quickReviewInputData = $('#quick_review_data').val();

	      if (JSON.parse(quickReviewInputData) !== undefined && JSON.parse(quickReviewInputData) !== null) {
	        var additional = $('.c-review-quick--additional');
	        var addHeading = additional.find('h4');
	        var addItemsParent = additional.find('ul');
	        var chartValues = quickReviewInputData != '[]' ? JSON.parse(quickReviewInputData)['customer_colleagues'].filter(function (d) {
	          return d.actual_clean.match(/[A-Za-z]+/g) !== null;
	        }) : [];
	        var addTitle = '';
	        var addItems = '';

	        chartValues.map(function (cv) {
	          addTitle = cv.label.split('-')[0].trim();
	          var addLabel = cv.label.split('-')[1].trim();

	          addItems += '<li class="additional--item' + (cv.market_objective_clean === cv.actual_clean ? ' green' : ' red') + '">\n                        <span class="label">' + addLabel + '</span>\n                        <span class="value"><span>' + cv.actual_clean + '</span><i class="' + (cv.market_objective_clean === cv.actual_clean ? 'fi-check-circle' : 'fi-close-circle') + '"></i></span>\n                      </li>';
	        });

	        addHeading.text(addTitle);
	        addItemsParent.html(addItems);
	      }
	    }
	  };

	  var quickReviewQueryString = function quickReviewQueryString() {

	    var queryStr = 'review';
	    var item = 'select[id*="edit-review"]';

	    if ($('.page-performance-metrics:not(.page-compare)').length) {

	      if ($('.page-performance-metrics').hasClass('page-timeline')) {
	        queryStr = 'market';
	        item = 'select[id*="edit-market"]';
	      }

	      var reviewSelect = $('.page-performance-metrics').find(item);
	      var reviewSelectVal = reviewSelect.val();

	      var currentUrl = window.location.href;
	      var currentUrlClean = currentUrl.split('?')[0];

	      if (currentUrl.indexOf('?' + queryStr + '=') === -1 && reviewSelectVal !== '') {
	        window.history.pushState({}, '', currentUrlClean + '?' + (queryStr === 'review' ? $.param({ review: reviewSelectVal }) : $.param({ market: reviewSelectVal })));
	      }

	      if (currentUrl.indexOf('?' + queryStr + '=') !== -1 && reviewSelectVal === '') {
	        window.history.pushState({}, '', currentUrlClean);
	      }

	      if (currentUrl.indexOf('?' + queryStr + '=') !== -1 && reviewSelectVal !== '') {
	        window.history.pushState({}, '', currentUrlClean + '?' + (queryStr === 'review' ? $.param({ review: reviewSelectVal }) : $.param({ market: reviewSelectVal })));
	      }
	    }
	  };

	  var autoSubmitFilters = function autoSubmitFilters(el, eventType, fieldType) {
	    var element = $(el).find(fieldType);
	    var submit = $(el).find('.form-submit');

	    element.on(eventType, function () {
	      submit.trigger('click');
	    });
	  };

	  var top20MarketsFlag = function top20MarketsFlag() {
	    var marketSelect = $('select[id*="-market"]');
	    var topMarketsIDs = drupalSettings.topMarkets;

	    marketSelect.each(function (index, el) {
	      var $market = $(el);
	      var selectedMarket = $market.val();

	      if (topMarketsIDs) {
	        if (topMarketsIDs.indexOf(selectedMarket) !== -1) {
	          $market.next().find('.select2-selection__rendered').append('<sup>Top 20</sup>');
	        }

	        $market.on('select2:open', function () {
	          setTimeout(function () {
	            var option = $('.select2-results__options').find('.select2-results__option');

	            option.each(function (index, el) {
	              var idArray = $(el).attr('data-select2-id').split('-');
	              var optionId = idArray[idArray.length - 1];

	              if (topMarketsIDs.indexOf(optionId) !== -1 && !$(el).children('sup').length && $(el).text() !== 'Select') {
	                $(el).append('<sup>Top 20</sup>');
	              }
	            });
	          }, 50);
	        });

	        $market.on('select2:select', function (e) {
	          if (topMarketsIDs.indexOf($(e.currentTarget).val()) !== -1) {
	            $market.next().find('.select2-selection__rendered').append('<sup>Top 20</sup>');
	          } else {
	            $market.next().find('.select2-selection__rendered').find('sup').remove();
	          }
	        });
	      }
	    });
	  };

	  var highlightFocusedRow = function highlightFocusedRow(el) {
	    el.each(function (index, element) {
	      $(element).on('focus blur', function (e) {
	        if (e.type == 'focus') {
	          $(e.currentTarget).closest('.form-wrapper').addClass('is-focused');
	        } else {
	          $(e.currentTarget).closest('.form-wrapper').removeClass('is-focused');
	        }
	      });
	    });
	  };

	  var inputNumberSteps = function inputNumberSteps(step, parent) {
	    if (parent.length) {
	      $('input[type="number"]').each(function (index, el) {
	        $(el).attr('step', step).val($(el).attr('step', step).val().split('.')[0]);
	      });
	    }
	  };

	  var descriptionIconAdd = function descriptionIconAdd(el) {
	    el.each(function (index, e) {
	      var desc = $(e).find('.description');
	      var label = $(e).find('label:not(.option)');
	      if (desc.length) {
	        if (!label.find('.description-toggle').length) {
	          label.html('<span>' + label.text() + '</span>');
	          desc.attr('data-heading', label.text()).append('<a class="description-close" tabindex="-1" href="javascript:;"><i class="fi-close"></i></a>');
	          label.append('<div class="description-tooltip"><a class="description-toggle" tabindex="-1" href="javascript:;"><i class="fi-info-circle"></i></a></div>');
	          label.find('.description-tooltip').append(desc);
	        }
	      }
	    });

	    $('.description-toggle').on('click', function (e) {
	      var $this = $(e.currentTarget);
	      var desc = $this.closest('.form-item').find('.description');

	      $('.description-tooltip').find('.description').removeClass('is-active');

	      if (!desc.hasClass('is-active')) {
	        desc.addClass('is-active');
	      } else {
	        desc.removeClass('is-active');
	      }
	    });

	    $('.description-close').on('click', function (e) {
	      var $this = $(e.currentTarget);
	      var desc = $this.closest('.description');
	      desc.removeClass('is-active');
	    });

	    $(document).on('click', function (e) {
	      var $this = $(e.target).parent();
	      !$this.closest('.description-tooltip').length ? $('.description').removeClass('is-active') : null;
	    });
	  };

	  var numberFormat = function numberFormat(locale, number) {
	    return new Intl.NumberFormat('gb-GB').format(number);
	  };

	  var elementRelocation = function elementRelocation(el1, el2, type) {
	    if (el1.length && el2.length) {
	      switch (type) {
	        case 'append':
	          el1.append(el2);
	          break;
	        case 'insertAfter':
	          el1.insertAfter(el2);
	        default:
	          break;
	      }
	    }
	  };

	  var dateRangePickerInit = function dateRangePickerInit() {
	    var dateField = $('input[id*="edit-date-range"]');
	    var dateParent = dateField.closest('.c-review-timeline--date');
	    var picker = null;

	    // const rectX = dateField[0].getBoundingClientRect().left;

	    if (dateField.length) {
	      picker = new Lightpick({
	        field: dateField[0],
	        singleDate: false,
	        maxDate: moment(),
	        orientation: 'right',
	        format: 'D MMM YYYY',
	        onOpen: function onOpen() {
	          dateParent.addClass('is-open');

	          // potential fix 
	          // const rectXOnOpen = $(this.el)[0].getBoundingClientRect().left;

	          // if (rectX !== rectXOnOpen) {
	          //   $(this.el).css('left', `${rectX}px`);
	          // }
	        },
	        onClose: function onClose() {
	          dateParent.removeClass('is-open');
	        },
	        onSelect: function onSelect(start, end) {
	          dateParent.addClass('date-selected');

	          setTimeout(function () {
	            if (start && end && typeof end._i !== 'string') {
	              dateParent.find('.form-submit').trigger('click');
	            }
	          }, 100);
	        }
	      });

	      if (picker.getStartDate() && picker.getEndDate()) {
	        dateParent.addClass('date-selected');
	      }
	    }

	    // reset date
	    var clearDateBtn = dateParent.find('.clear-date');

	    clearDateBtn.on('click', function (e) {
	      e.preventDefault();

	      dateParent.removeClass('date-selected');
	      dateField.val('');

	      if (picker.getStartDate() && picker.getEndDate()) {
	        dateParent.find('.form-submit').trigger('click');
	      }

	      picker.setDateRange(null, null);
	    });
	  };

	  // assessment flag when its changed
	  var assChangedFlag = [false, false, false, false];

	  var fullReviewAssessmentSelectsFill = function fullReviewAssessmentSelectsFill() {
	    var filters = $('.c-review--filters');

	    filters.find('.form-item[class*="-review"]').find('select').each(function (index, assEl) {
	      var assessmentSelect = $(assEl);

	      assessmentSelect.on('change', function (e) {
	        if (assessmentSelect.val() !== '') {
	          assChangedFlag[index] = true;
	        } else {
	          assChangedFlag[index] = false;
	        }
	      });

	      if (assessmentSelect.val() !== '' && assChangedFlag[index]) {
	        var siblingsSelects = assessmentSelect.closest('.form-item').siblings().find('select[data-value]');

	        siblingsSelects.each(function (index, siblingAssEl) {
	          var siblingsSelectsValue = $(siblingAssEl).attr('data-value');
	          $(siblingAssEl).val(siblingsSelectsValue).trigger('change.select2');
	        });

	        assChangedFlag[index] = false;
	      }
	    });
	  };

	  var fullReviewCompare = function fullReviewCompare() {
	    var filters = $('.c-review--filters');
	    var allFilterItems = filters.children('fieldset');
	    var addNewCompareItem = $('.compare-actions').children('.add-item');
	    var removeCompareItem = filters.find('.remove-item');
	    var selectedReviews = [];

	    // add tabs 
	    !$('.filters-tabs').length ? $('.page-compare .c-review--filters').before('<div class="filters-tabs">\n        <a class="filter-tabs--tab active" href="#">1st</a>\n        <a class="filter-tabs--tab" href="#">2nd</a>\n        <a class="filter-tabs--tab" href="#">3rd</a>\n        <a class="filter-tabs--tab" href="#">4th</a>\n      </div>') : null;

	    var filtersTabsContainer = $('.filters-tabs');
	    var filtersTabs = filtersTabsContainer.children('.filter-tabs--tab');

	    if ($(window).outerWidth() >= 768) {
	      // for desktop

	      allFilterItems.each(function (rowIndex, row) {
	        $(row).find('select').each(function (selectIndex, select) {
	          if ($(row).hasClass('hidden') && $(select).val() !== '') {
	            $(row).removeClass('hidden');
	          }
	        });

	        setTimeout(function () {
	          if (filters.children('fieldset:not(.hidden)').length < 2) {
	            $(row).removeClass('hidden');
	          }
	        }, 10);
	      });

	      if (filters.children('fieldset.hidden').length >= 2) {
	        filters.addClass('compare-item-not-removable');
	      }

	      if (!filters.children('fieldset.hidden').length) {
	        $('.compare-actions').addClass('disabled');
	      }
	    } else {

	      // for mobile 
	      filtersTabs.removeClass('not-empty');

	      filters.removeClass('compare-item-not-removable');

	      allFilterItems.each(function (rowIndex, row) {
	        if ($(row).find('select[id*="-review"]').val() !== '') {
	          filtersTabs.eq($(row).index()).addClass('not-empty');
	          $(row).addClass('not-empty');
	        }
	      });

	      allFilterItems.eq(0).removeClass('hidden');
	    }

	    $('.full-review-compare-form, .quick-review-compare-form').find('select[id*="-review"]').each(function (index, el) {
	      if ($(el).val() !== '' && !selectedReviews.indexOf($(el).val()) !== -1) {
	        selectedReviews.push($(el).val());
	      }
	    });

	    var currentUrl = window.location.href;
	    var currentUrlClean = currentUrl.split('?')[0];

	    window.history.pushState({}, '', currentUrlClean + '?' + $.param({ reviews: selectedReviews.join('|') }));

	    // trigger add new compare item on tab add click
	    filtersTabs.on('click', function (e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);
	      var $thisIndex = $this.index();

	      $this.addClass('active').siblings().removeClass('active');
	      allFilterItems.eq($thisIndex).removeClass('hidden').siblings('fieldset').addClass('hidden');
	    });

	    // add new compare item
	    addNewCompareItem.off('click').on('click', function (e) {
	      e.preventDefault();

	      if (filters.children('fieldset.hidden').length) {
	        filters.children('fieldset.hidden').eq(0).removeClass('hidden');
	        filtersTabsContainer.find('.filter-tabs--tab.hidden').eq(0).removeClass('hidden');

	        if (filters.children('fieldset.hidden').length < 2) {
	          filters.removeClass('compare-item-not-removable');
	        }

	        if (!filters.children('fieldset.hidden').length) {
	          $('.compare-actions').addClass('disabled');
	        }
	      }
	    });

	    // remove compare item
	    removeCompareItem.off('click').on('click', function (e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);
	      var assValue = $this.prev().find('select').val();

	      if (filters.children('fieldset.hidden').length < 2) {
	        $this.closest('fieldset').addClass('hidden');

	        $this.closest('fieldset').find('select').each(function (index, el) {
	          $(el).val(null).trigger('change.select2');
	        });
	      }

	      if ($(window).outerWidth() < 768) {
	        $this.closest('fieldset').find('select').each(function (index, el) {
	          $(el).val(null).trigger('change.select2');
	        });
	      }

	      if (filters.children('fieldset.hidden').length >= 2) {
	        filters.addClass('compare-item-not-removable');
	      }

	      if (filters.children('fieldset.hidden').length) {
	        $('.compare-actions').removeClass('disabled');
	      }

	      var currentUrl = window.location.href;
	      var currentUrlClean = currentUrl.split('?')[0];

	      selectedReviews = selectedReviews.filter(function (sr) {
	        return assValue !== sr;
	      });

	      window.history.pushState({}, '', currentUrlClean + '?' + $.param({ reviews: selectedReviews.join('|') }));

	      $('[id*="edit-filters-rebuild"]').trigger('mousedown');
	    });

	    // colour items

	    var emptyRows = 0;

	    var colorItems = allFilterItems.not('.hidden');

	    if ($(window).outerWidth() < 768) {
	      colorItems = allFilterItems;
	    }

	    colorItems.each(function (index, el) {
	      var compareColors = ['189,132,91', '64,70,92', '108,70,70', '149,173,172'];
	      var colorId = $(el).attr('id').split('-');

	      $(el).find('select[id*="-review"]').val() === '' ? emptyRows++ : emptyRows;

	      if ($(el).find('select[id*="-review"]').val() !== '') {
	        if ($('.full-review-compare-answers-form, .quick-review-compare-form').length) {
	          $('.reviews-info').children().eq(index - emptyRows).attr('data-color', $(el).attr('id'));

	          $('.c-review-quick--block-body').find('.row-item').each(function (pmIndex, pmRow) {
	            $(pmRow).find('.field-actual-value').eq(index - emptyRows).attr('data-color', $(el).attr('id'));
	          });

	          $('.answers-container').each(function (ansIndex, ansEl) {
	            $(ansEl).children().eq(index - emptyRows).attr('data-color', $(el).attr('id'));
	          });
	        }

	        $('.c-review-compare--table-row').eq(index - emptyRows).attr('data-color', $(el).attr('id')).attr('data-color-rgb', compareColors[colorId[colorId.length - 1]]);
	      }
	    });
	  };

	  var fullReviewTimelineUserQuery = function fullReviewTimelineUserQuery() {
	    var currentUrl = window.location.href;
	    var currentUrlClean = currentUrl.split('?')[0];

	    if ($('select[id*="edit-author"]').val() !== '') {
	      window.history.pushState({}, '', currentUrlClean + '?' + $.param({ user: $('select[id*="edit-author"]').val() }));
	    } else {
	      window.history.pushState({}, '', currentUrlClean);
	    }

	    $('select[id*="edit-author"]').on('change', function (e) {
	      var $this = $(e.currentTarget);

	      if ($this.val() !== '') {
	        window.history.pushState({}, '', currentUrlClean + '?' + $.param({ user: $this.val() }));
	      } else {
	        window.history.pushState({}, '', currentUrlClean);
	      }
	    });
	  };

	  var performanceLineChartInit = function performanceLineChartInit(el, chartData, update) {

	    var lineColors = ['rgb(108, 70, 70)', 'rgb(189, 132, 91)', 'rgb(197, 173, 126)', 'rgb(106, 70, 108)', 'rgb(91, 189, 149)', 'rgb(115, 172, 91)', 'rgb(149, 59, 79)', 'rgb(194, 110, 49)', 'rgb(65, 123, 56)', 'rgb(172, 97, 158)', 'rgb(64, 70, 92)', 'rgb(91, 120, 143)', 'rgb(149, 173, 172)', 'rgb(64, 88, 92)', 'rgb(94, 143, 91)', 'rgb(157, 149, 173)', 'rgb(40, 141, 153)', 'rgb(13, 99, 168)', 'rgb(138, 44, 44)', 'rgb(40, 93, 135)', 'rgb(50, 25, 78)'];

	    if ($(el).length) {
	      var sf = performanceFilters().length ? performanceFilters() : $('.page-dashboard').length ? ["Jaguar New Eligible Penetration", "Land Rover New Eligible Penetration"] : [];

	      console.log(sf);

	      var datasets = {};
	      var labels = [];
	      var preparedData = [];

	      var finalDatasets = [];

	      var currentDatasetIndex = 0;

	      // prepare labels
	      chartData.map(function (cd) {
	        labels.push(cd.date);

	        cd.data.map(function (data) {
	          if (sf.indexOf(data.label) !== -1) {
	            var dataset = {
	              av: data.actual_value,
	              gv: data.goal_value,
	              name: data.label
	            };

	            preparedData.push(dataset);
	            datasets[data.label.toLowerCase().replace(/\s/g, '_')] = preparedData.filter(function (b) {
	              return b.name === data.label;
	            });
	          }
	        });
	      });

	      // add empty data object to make space
	      labels.push('');
	      labels.unshift('');

	      Object.keys(datasets).forEach(function (key, index) {
	        var _finalDatasets$push, _finalDatasets$push2;

	        var av = [];
	        var gv = [];
	        var labelName = '';

	        datasets[key].map(function (ds, DSindex) {
	          av.push(ds.av);
	          gv.push(ds.gv);

	          labelName = ds.name;
	        });

	        av.push(null);
	        av.unshift(null);
	        gv.push(null);
	        gv.unshift(null);

	        finalDatasets.push((_finalDatasets$push = {
	          backgroundColor: lineColors[index],
	          borderColor: lineColors[index],
	          borderWidth: 2,
	          data: av,
	          fill: false,
	          label: 'Overall Score'
	        }, _defineProperty(_finalDatasets$push, 'label', labelName + ' (Actual)'), _defineProperty(_finalDatasets$push, 'lineTension', 0), _defineProperty(_finalDatasets$push, 'pointBackgroundColor', 'white'), _defineProperty(_finalDatasets$push, 'pointBorderWidth', 2), _defineProperty(_finalDatasets$push, 'pointHoverBackgroundColor', 'white'), _defineProperty(_finalDatasets$push, 'pointHoverBorderWidth', 2), _defineProperty(_finalDatasets$push, 'pointHoverRadius', 5), _defineProperty(_finalDatasets$push, 'pointRadius', 5), _finalDatasets$push));

	        finalDatasets.push((_finalDatasets$push2 = {
	          backgroundColor: lineColors[index],
	          borderColor: lineColors[index],
	          borderDash: [10, 5],
	          borderWidth: 2,
	          data: gv,
	          fill: false,
	          label: 'Overall Score'
	        }, _defineProperty(_finalDatasets$push2, 'label', labelName + ' (Objective)'), _defineProperty(_finalDatasets$push2, 'lineTension', 0), _defineProperty(_finalDatasets$push2, 'pointBackgroundColor', 'white'), _defineProperty(_finalDatasets$push2, 'pointBorderWidth', 2), _defineProperty(_finalDatasets$push2, 'pointHoverBackgroundColor', 'white'), _defineProperty(_finalDatasets$push2, 'pointHoverBorderWidth', 2), _defineProperty(_finalDatasets$push2, 'pointHoverRadius', 5), _defineProperty(_finalDatasets$push2, 'pointRadius', 5), _finalDatasets$push2));
	      });

	      // legend generate
	      var legendData = finalDatasets.filter(function (fd) {
	        return fd.label.indexOf('Actual') !== -1;
	      });

	      // reset legend
	      $('.c-quick-review-timeline--chart-legend').children().remove();

	      // append dataset in legend
	      legendData.map(function (ld) {
	        $('.c-quick-review-timeline--chart-legend').append('\n            <div class="legend-item">\n              <span class="legend-square" style="background-color: ' + ld.backgroundColor + '"></span>\n              <span class="legend-item-name">' + ld.label.split(' (')[0] + '</span>\n            </div>\n          ');
	      });

	      var data = {
	        datasets: finalDatasets,
	        labels: labels
	      };

	      var options = {
	        events: ['mousemove', 'mouseout', 'touchstart', 'touchend'],
	        maintainAspectRatio: false,
	        legend: {
	          display: false
	        },
	        scales: {
	          yAxes: [{
	            gridLines: {
	              drawTicks: false
	            },
	            ticks: {
	              beginAtZero: true,
	              fontColor: '#525252',
	              fontFamily: "'Arial', sans-sefif",
	              fontSize: 14,
	              fontStyle: 'bold',
	              min: 0,
	              padding: 20,
	              callback: function callback(value, index, values) {
	                return $('.page-dashboard').length ? value + '%' : value;
	              }
	            }
	          }],
	          xAxes: [{
	            gridLines: {
	              drawTicks: false,
	              display: $('.page-dashboard').length ? false : true
	            },
	            ticks: {
	              beginAtZero: true,
	              fontColor: '#525252',
	              fontFamily: "'Arial', sans-sefif",
	              fontSize: 14,
	              fontStyle: 'bold',
	              padding: 20
	            }
	          }]
	        },
	        tooltips: {
	          mode: 'index',
	          intersect: false,
	          enabled: false,
	          xPadding: 0,
	          yPadding: 0,
	          custom: function custom(tooltipModel) {
	            // Tooltip Element
	            var tooltipEl = document.getElementById('chartjs-tooltip');

	            // add carret bottom class on init
	            $(tooltipEl).children().addClass('carret-bottom');

	            // Create element on first render
	            if (!tooltipEl) {
	              tooltipEl = document.createElement('div');
	              tooltipEl.id = 'chartjs-tooltip';
	              tooltipEl.innerHTML = '<div class="chart-tooltip"></div>';
	              document.body.appendChild(tooltipEl);
	            }

	            // Hide if no tooltip
	            if (tooltipModel.opacity === 0) {
	              tooltipEl.style.opacity = 0;
	              return;
	            }

	            // Set caret Position
	            tooltipEl.classList.remove('above', 'below', 'no-transform');

	            if (tooltipModel.yAlign) {
	              tooltipEl.classList.add(tooltipModel.yAlign);
	            } else {
	              tooltipEl.classList.add('no-transform');
	            }

	            function getBody(bodyItem) {
	              return bodyItem.lines;
	            }

	            // Set Text
	            if (tooltipModel.body) {
	              var bodyLines = tooltipModel.body.map(getBody);

	              var innerHtml = '<span class="chart-tooltip--carret"></span><div class="chart-tooltip--head fluid">';

	              innerHtml += '<div class="chart-tooltip--heading"><strong>' + tooltipModel.title + '</strong></div>';

	              innerHtml += '</div><div class="chart-tooltip--body performance-timeline">';

	              bodyLines.forEach(function (body, i) {

	                if (bodyLines[i].length) {
	                  var bodyStr = body[0];
	                  var label = bodyStr.split(' : ')[0];
	                  var value = bodyStr.split(' : ')[1];

	                  var colors = tooltipModel.labelColors[i];
	                  var style = 'background:' + colors.borderColor;

	                  var span = label.indexOf('Objective') !== 1 ? '\n                                  <span class="chart-tooltip--square goal">\n                                      <span style="' + style + '"></span>\n                                      <span style="' + style + '"></span>\n                                      <span style="' + style + '"></span>\n                                  </span>' : '<span class="chart-tooltip--square actual"><span style="' + style + '"></span></span>';

	                  innerHtml += '<div class="chart-tooltip--item">\n                                      ' + span + '\n                                      <span class="chart-tooltip--label">\n                                        ' + label + ': ' + value + '\n                                      </span>\n                                  </div>';
	                }
	              });

	              innerHtml += '</div>';

	              var tableRoot = tooltipEl.querySelector('.chart-tooltip');
	              tableRoot.innerHTML = innerHtml;
	            }

	            // `this` will be the overall tooltip
	            var position = this._chart.canvas.getBoundingClientRect();

	            // Display, position, and set styles for font
	            tooltipEl.style.opacity = 1;
	            tooltipEl.style.position = 'absolute';
	            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX - $(tooltipEl).width() / 2 + 'px';
	            $(window).outerWidth() < 768 ? $(tooltipEl).find('.chart-tooltip--carret')[0].style.left = position.left + window.pageXOffset + tooltipModel.caretX - 20 + 'px' : null;
	            tooltipEl.style.top = position.top + window.pageYOffset + 25 + 'px';
	            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
	            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
	            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
	            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
	            tooltipEl.style.pointerEvents = 'none';
	          },
	          callbacks: {
	            afterLabel: function afterLabel(tooltipItem, data) {
	              currentDatasetIndex = tooltipItem.index;
	            },
	            label: function label(tooltipItem, data) {
	              var value = '';
	              var ds = data.datasets[tooltipItem.datasetIndex];
	              var dsData = +ds.data[tooltipItem.index];

	              var percentage = $('.page-dashboard').length ? '%' : '';

	              if (ds.label.indexOf('(Actual)') !== -1) {
	                if (ds.label.indexOf("Wholesale - no noise") !== -1 || ds.label.indexOf("Regulatory Compliance") !== -1) {
	                  if (dsData > +data.datasets[tooltipItem.datasetIndex + 1].data[tooltipItem.index]) {
	                    value = '<span style="color: #d8304f">' + dsData + percentage + '</span>';
	                  } else {
	                    value = '<span style="color: #00ca61">' + dsData + percentage + '</span>';
	                  }
	                } else {
	                  if (dsData >= +data.datasets[tooltipItem.datasetIndex + 1].data[tooltipItem.index]) {
	                    value = '<span style="color: #00ca61">' + dsData + percentage + '</span>';
	                  } else {
	                    value = '<span style="color: #d8304f">' + dsData + percentage + '</span>';
	                  }
	                }
	              } else {
	                value = '<span>' + dsData + percentage + '</span>';
	              }

	              return ds.label + ' : ' + value;
	            }
	          }
	        }
	      };

	      renderChart('line', data, options, el, update);
	    }
	  };

	  var performanceFilters = function performanceFilters() {
	    var checkboxes = $('.c-quick-review-timeline--checkboxes').find('input:checked');
	    var selectedFilters = [];

	    checkboxes.each(function (index, input) {
	      selectedFilters.push($(input).data('value'));
	    });

	    $('.c-quick-review-timeline--filters').find('.hide-show-filters').off('click').on('click', function (e) {
	      e.preventDefault();

	      var $this = $(e.currentTarget);

	      if ($this.hasClass('is-hidden')) {
	        $this.removeClass('is-hidden').find('span').text('Hide Filters');
	        $('.c-quick-review-timeline--categories').addClass('expanded');
	      } else {
	        $this.addClass('is-hidden').find('span').text('Show Filters');
	        $('.c-quick-review-timeline--categories').removeClass('expanded');
	      }
	    });

	    $('.c-quick-review-timeline--category').find('.ios-checkbox input').off('click').on('click', function (e) {
	      var $this = $(e.currentTarget);
	      var checkboxes = $this.parent().prev().find('input');

	      if ($this.is(':checked')) {
	        checkboxes.each(function (index, checkbox) {
	          $(checkbox).prop('checked', true).trigger('change');
	        });
	      } else {
	        checkboxes.each(function (index, checkbox) {
	          $(checkbox).prop('checked', false).trigger('change');
	        });
	      }
	    });

	    $('.c-quick-review-timeline--checkboxes').find('input').off('change').on('change', function () {
	      var inputs = $('.c-quick-review-timeline--checkboxes').find('input:checked');
	      var selectedFilters = [];

	      inputs.each(function (index, input) {
	        selectedFilters.push($(input).data('value'));
	      });

	      performanceLineChartInit($('#line-performance-timeline'), $('input#quick_review_timeline_data').length ? JSON.parse($('input#quick_review_timeline_data').val()).reverse() : [], true);
	    });

	    return selectedFilters;
	  };

	  var dashBoardQuickReviewGraphSwitch = function dashBoardQuickReviewGraphSwitch() {

	    $('.c-dashboard--results .c-review-quick--graphs').children('.c-review-quick--column:not(:first-child)').each(function (index, el) {
	      console.log($(el));
	      $(el).addClass('not-visible');
	    });

	    $('.chart-switch a').off('click').on('click', function (e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);
	      var $selectedGraph = $this.data('graph');
	      var $selectedGraphCanvas = $('.c-review-quick--graphs').children('.c-review-quick--column.' + $selectedGraph);

	      $this.addClass('active').removeClass('not-visible').siblings().removeClass('active').addClass('not-visible');

	      $selectedGraphCanvas.addClass('active').removeClass('not-visible').siblings().removeClass('active').addClass('not-visible');
	    });
	  };

	  var getOfFilterLabelsForMobile = function getOfFilterLabelsForMobile() {

	    var selector = '.c-review--filters';

	    if ($('.page-full-review.page-compare').length) {
	      selector = '.c-review--filters .item-fieldset:first-child .fieldset-wrapper';
	    }

	    if ($('.page-dashboard').length) {
	      selector = '.c-dashboard--filters';
	    }

	    var filterFields = $(selector).children().not('.fieldset-legend-copy').not('.remove-item').not('input');

	    filterFields.each(function (index, el) {
	      if (!$(el).find('.custom-field-label').length) {
	        // $(el).prepend($(el).find('label').length ? `<span class="custom-field-label">${ $(el).find('label').text()}</span>` : `<span class="custom-field-label without-label">without-label</span>`)
	      }
	    });
	  };

	  var loginTabsSwitch = function loginTabsSwitch() {
	    var tabs = $('.c-login--content').find('a[data-toggle]');
	    var currentUrl = window.location.href;

	    var messageText = $('.c-login--box').find('.c-messages').text().trim().split(' ')[0];

	    if ($('#edit-current-pass--description').length) {

	      var currentPasswordResetLink = $('#edit-current-pass--description').find('a');
	      var currentPasswordResetLinkHref = currentPasswordResetLink.attr('href');

	      currentPasswordResetLink.attr('href', currentPasswordResetLinkHref + '?form=forgot');
	    }

	    $('.c-login--content').find('.tab-pane').eq(0).fadeIn(300);

	    if (currentUrl.indexOf('?form=forgot') !== -1 || messageText == 'Forgot' || messageText == 'Unrecognized' || messageText == 'The') {
	      tabs.eq(0).removeClass('active');
	      tabs.eq(1).addClass('active');
	      $('.c-login--content').find('.tab-pane').eq(0).fadeOut(0);
	      $('.c-login--content').find('.tab-pane').eq(1).fadeIn(0);
	    }

	    tabs.on('click', function (e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);
	      var tabId = $this.data('toggle');

	      $('.c-login--content').find('.tab-pane[id="' + tabId + '"]').delay(200).fadeIn(200).siblings().fadeOut(200).delay(0);
	      $this.addClass('active').siblings().removeClass('active');
	    });
	  };

	  var mobileNavTrigger = function mobileNavTrigger() {
	    $('.mobile-nav-trigger').on('click', function (e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);

	      if (!$this.hasClass('active')) {
	        $this.addClass('active');
	        $('.c-layout--sidebar').addClass('is-visible');
	      } else {
	        $this.removeClass('active');
	        $('.c-layout--sidebar').removeClass('is-visible');
	      }
	    });
	  };

	  var userInitials = function userInitials() {
	    $('.c-user-menu--picture, .field--name-user-picture').each(function (userIndex, userImg) {
	      var usersName = $(userImg).next().children().eq(0).text();

	      var _usersName$split = usersName.split(' '),
	          firstName = _usersName$split[0],
	          lastName = _usersName$split[1];

	      if (usersName.split(' ').length > 1) {
	        var initials = '' + firstName.slice(0, 1) + lastName.slice(0, 1);

	        if ($(userImg).find('a').length) {
	          $(userImg).find('a').addClass('initials-link').html('<span class="initials">' + initials + '</span>');
	        } else {
	          $(userImg).html('<span class="initials">' + initials + '</span>');
	        }
	      }
	    });
	  };

	  // docready
	  $(document).ready(function () {
	    console.log('ready');
	    var wScroll = $(document).scrollTop();

	    if (!!navigator.userAgent.match(/Trident\/7\./)) {
	      $('body').addClass('ie11');
	    }

	    beforeUnloadPopup($('.page-full-review.page-create'), 'Are you sure you want to leave?');

	    // check if device is touch ready
	    touchDevice();

	    // window scrolled 
	    wScroll > 0 && $(window).outerWidth() < 610 ? $('.c-layout--header, .c-layout--sidebar, .mobile-nav-trigger').addClass('scrolled') : $('.c-layout--header, .c-layout--sidebar, .mobile-nav-trigger').removeClass('scrolled');

	    // start new dropdown menu
	    startNewDropdown();

	    if ($(window).outerWidth() >= 768) {
	      // sidebar collapse expand
	      sidebarCollapseExpand();
	    }

	    // faq collapse expand
	    faqCollapseExpand();

	    // disable bussiness partner
	    disableBusinessPartner();

	    // full review reset form (all fields / all indicators)
	    fullReviewResetForm();

	    // select 2 init
	    select2Init();

	    // enhance member search form
	    memberSearchFormEnhance();

	    // user menu dropdown
	    userMenuDropdown();

	    // full review questions - collapse / calc
	    fullReviewQuestions();

	    // indicator which question is answered
	    if (!$('.page-full-review.page-compare').length) {
	      questionAnswerIndicator();
	    }

	    // question asnwers wrap first word in label
	    answersLabelWrap();

	    if ($('.page-compare').length) {
	      fullReviewCompare();
	    }

	    if ($('.page-full-review.page-timeline').length) {
	      fullReviewTimelineUserQuery();
	    }

	    if ($('body').hasClass('page-dashboard')) {

	      // full review radar chart init
	      fullReviewRadarChartInit($('#radar-chart'), $('#full_review_data').length ? JSON.parse($('#full_review_data').val()) : [], 'selfAssessment');

	      // full review timeline
	      fullReviewTimeline($('#stacked-bar-timeline'));

	      // quick review bar charts
	      quickReviewBarChartInit($('.quick-review-bar'));

	      // quick review additional items
	      quickReviewAdditional();

	      // quick review timeline
	      performanceLineChartInit($('#line-performance-timeline'), $('input#quick_review_timeline_data').length ? JSON.parse($('input#quick_review_timeline_data').val()).reverse() : []);
	    } else if (!$('.page-performance-metrics, .page-full-review').hasClass('page-timeline')) {

	      // quick review bar charts
	      quickReviewBarChartInit($('.quick-review-bar'));

	      // quick review additional items
	      quickReviewAdditional();

	      // full review radar chart init
	      fullReviewRadarChartInit($('#radar-chart'), $('#full_review_data').length ? JSON.parse($('#full_review_data').val()) : [], 'selfAssessment');

	      // full review compare
	      fullReviewRadarChartInit($('#full-review-compare'), $('input#compare_data').length ? JSON.parse($('input#compare_data').val()) : [], 'compareAssessment');
	    } else if ($('.page-performance-metrics, .page-full-review').hasClass('page-timeline')) {

	      // quick review timeline
	      performanceLineChartInit($('#line-performance-timeline'), $('input#quick_review_timeline_data').length ? JSON.parse($('input#quick_review_timeline_data').val()).reverse() : []);

	      // full review timeline
	      fullReviewTimeline($('#stacked-bar-timeline'));
	    }

	    // update query string according to selected review
	    quickReviewQueryString();

	    // radial progress chart
	    radialProgressJSInit();

	    // infinite scroll pagination
	    if ($('.page-full-review').length) {
	      infiniteScroll('#edit-results tbody');
	    }

	    if ($('.page-asset-library').length) {
	      infiniteScroll('#asset-library-results');
	    }

	    // auto submit filters - element wrapper / event (change etc..) / input type (input, select, textarea)
	    autoSubmitFilters($('.c-review--filters'), 'change', 'select');

	    highlightFocusedRow($('.quick-review-form').find('.field-group-html-element').find('input[type="number"]'));

	    inputNumberSteps(1, $('.quick-review-form'));

	    descriptionIconAdd($('.c-review-quick--category').find('.form-item'));

	    top20MarketsFlag();

	    assetLibraryAutoSubmit();

	    $('.review-count-input').length ? $('.review-count-input').attr('title', $('.review-count-input').text()) : null;

	    fullReviewAssessmentSelectsFill();

	    performanceFilters();

	    dashBoardQuickReviewGraphSwitch();

	    // getOfFilterLabelsForMobile();

	    loginTabsSwitch();

	    mobileNavTrigger();

	    userInitials();
	  });

	  // winresize
	  $(window).resize(function () {
	    if ($(window).outerWidth() < 768) {
	      $('.c-layout').removeClass('sidebar-collapsed');
	      $('.c-layout').removeClass('sidebar-collapsed');
	      $('body').removeClass('body-sidebar-collapsed');
	      $('body').removeClass('body-sidebar-collapsed-load');
	    } else {

	      if (localStorage.getItem('sidebar-collapsed') == 'true') {
	        $('.c-layout').addClass('sidebar-collapsed');
	        $('.c-layout').addClass('sidebar-collapsed');
	        $('body').addClass('body-sidebar-collapsed');
	        $('body').addClass('body-sidebar-collapsed-load');
	      }
	    }
	  });

	  $(document).ajaxStart(function () {
	    $('body').addClass('ajaxProcess');
	  });

	  // ajaxcomplete
	  $(document).ajaxComplete(function (a, b, c) {
	    $('body').removeClass('ajaxProcess');

	    // disable bussiness partner
	    disableBusinessPartner();

	    fullReviewResetForm();

	    // select 2 init
	    select2Init();

	    // enhance member search form
	    memberSearchFormEnhance();

	    // full review questions - collapse / calc
	    fullReviewQuestions();

	    // full review timeline
	    fullReviewTimeline($('#stacked-bar-timeline'));

	    if ($('.page-compare').length) {
	      fullReviewCompare();
	    }

	    if ($('.page-full-review.page-timeline').length) {
	      fullReviewTimelineUserQuery();
	    }

	    fullReviewAssessmentSelectsFill();

	    if ($('body').hasClass('page-dashboard')) {

	      // full review radar chart init
	      fullReviewRadarChartInit($('#radar-chart'), $('#full_review_data').length ? JSON.parse($('#full_review_data').val()) : [], 'selfAssessment');

	      // full review timeline
	      fullReviewTimeline($('#stacked-bar-timeline'));

	      // quick review bar charts
	      quickReviewBarChartInit($('.quick-review-bar'));

	      // quick review additional items
	      quickReviewAdditional();

	      // quick review timeline
	      performanceLineChartInit($('#line-performance-timeline'), $('input#quick_review_timeline_data').length ? JSON.parse($('input#quick_review_timeline_data').val()).reverse() : []);
	    } else if (!$('.page-performance-metrics, .page-full-review').hasClass('page-timeline')) {

	      // quick review bar charts
	      quickReviewBarChartInit($('.quick-review-bar'));

	      // quick review additional items
	      quickReviewAdditional();

	      // full review compare
	      fullReviewRadarChartInit($('#full-review-compare'), $('input#compare_data').length ? JSON.parse($('input#compare_data').val()) : [], 'compareAssessment');
	    } else if ($('.page-performance-metrics, .page-full-review').hasClass('page-timeline')) {

	      // quick review timeline
	      performanceLineChartInit($('#line-performance-timeline'), $('input#quick_review_timeline_data').length ? JSON.parse($('input#quick_review_timeline_data').val()).reverse() : []);

	      // full review timeline
	      fullReviewTimeline($('#stacked-bar-timeline'));
	    }

	    // update query string according to selected review
	    quickReviewQueryString();

	    // indicator which question is answered
	    if (!$('.page-full-review.page-compare').length) {
	      questionAnswerIndicator();
	    }

	    // make table row clickabile
	    tableRowLink();

	    descriptionIconAdd($('.c-review-quick--category').find('.form-item'));

	    // labels
	    answersLabelWrap();

	    top20MarketsFlag();

	    elementRelocation($('.c-quick-review-timeline--chart-head'), $('.quick-review-timeline-form .c-review-timeline--date'), 'append');
	    dateRangePickerInit();

	    if ($('.full-review-compare-answers-form').length) {
	      $('.ui-dialog-titlebar').append($('.reviews-info'));
	    }

	    dashBoardQuickReviewGraphSwitch();

	    // getOfFilterLabelsForMobile();
	  });

	  // win scroll
	  $(window).on('scroll', function (e) {
	    var $this = $(e.currentTarget);
	    var wScroll = $this.scrollTop();

	    wScroll > 0 && $(window).outerWidth() < 610 ? $('.c-layout--header, .c-layout--sidebar, .mobile-nav-trigger').addClass('scrolled') : $('.c-layout--header, .c-layout--sidebar, .mobile-nav-trigger').removeClass('scrolled');
	  });

	  // winresize
	  window.onload = function () {
	    console.log('load');
	    $('html, body').addClass('site-fully-loaded');

	    // make table row clickabile
	    tableRowLink();

	    // show message on window load
	    showMessages(true);

	    // close messages on click
	    closeMessages();

	    // close messages after 15 sec
	    setTimeout(function () {
	      showMessages(false);
	    }, 15000);

	    elementRelocation($('.c-quick-review-timeline--chart-head'), $('.quick-review-timeline-form .c-review-timeline--date'), 'append');
	    dateRangePickerInit();
	  }();
	});

/***/ })
/******/ ]);